// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface XBlockView
 */
export interface XBlockView {
    /**
     * 
     * @type {string}
     * @memberof XBlockView
     */
    content: string;
    /**
     * Each entry in this array is a tuple of [id/hash, [type, URL, mimetype, head/foot]]
     * @type {Array<any>}
     * @memberof XBlockView
     */
    resources: Array<any>;
}

export function XBlockViewFromJSON(json: any): XBlockView {
    return {
        'content': json['content'],
        'resources': json['resources'],
    };
}

export function XBlockViewToJSON(value?: XBlockView): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'content': value.content,
        'resources': value.resources,
    };
}


